<template>
  <div class="container-top" :class="{ 'container-wide': lgAndUp || xlAndUp }">
    <div class="row mt-5">
      <div
        class="col-md-12 d-flex justify-content-between flex-wrap mt-2 mt-md-0"
      >
        <div class="text-head font-weight-bold h2 text-black">Subscription</div>
        <div>
          <el-button size="large" round @click="billingHistory">
            <span class="text-head font-weight-600 text-black"
              >Billing History</span
            ></el-button
          >
        </div>
      </div>
      <div class="col-md-12 fw-300 s-18 mt-1" style="color: #616161">
        Select the subscription that suit your church and the additional tools
        <br />
        you need for your church growth.
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex flex-wrap justify-content-center mt-4">
        <!-- <div class="row"> -->
        <div class="col-md-6 col-12">
          <div class="row sub py-4 h-100">
            <div class="col-md-12">
              <div class="row bg-white pb-4">
                <div class="col-md-6 col-lg-6 col-12">
                  <div class="py-2 fw-400 text-dak">
                    Select Subscription Plan
                    <span class="text-danger">*</span>
                  </div>
                  <el-select-v2
                    :options="
                      UserSubscriptionPlans.map((i) => ({
                        label: i.description,
                        value: i.id,
                      }))
                    "
                    v-model="selectedPlanId"
                    placeholder="Select plan"
                    @change="setSelectedPlan"
                    size="large"
                    class="w-100"
                  />
                  <div
                    class="mt-2 fw-400 s-13 text-right pl-md-0"
                    style="color: #393b3e"
                  >
                    Membership:
                    {{
                      selectedPlan && selectedPlan.membershipSize
                        ? selectedPlan.membershipSize.toLocaleString()
                        : ""
                    }}
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                  <div class="py-2 fw-400 text-dak">
                    Select Duration (month)
                  </div>
                  <el-select-v2
                    :options="
                      selectMonths.map((i) => ({
                        label: i.name,
                        value: i.name,
                      }))
                    "
                    v-model="selectMonthId"
                    placeholder="Select duration"
                    @change="setSelectedDuration"
                    size="large"
                    class="w-100"
                  />
                  <div
                    class="ml-1 mt-2 fw-400 s-13 text-right normal-text pl-md-0"
                    style="color: #393b3e"
                  >
                    {{
                      selectedPlan &&
                      Object.keys(selectedPlan).length > 0 &&
                      selectedPlan.currency
                        ? selectedPlan.currency.symbol
                        : ""
                    }}
                    {{ subselectedDuratn.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12 col-lg-12 py-3" style="background: #eeeeee">
              <span
                class="bg-black text-white border-radius-8 p-2 text-head font-weight-600"
                >+ADD-ONS</span
              >
            </div>
            <div class="col-md-12 col-lg-12 mt-2" style="color: #393b3e">
              <span class="s-13">No Add-on added</span>
            </div> -->
            <div class="col-md-12 bg-white px-0 col-12">
              <div class="h-100 col-md-12 px-0">
                <div
                  style="background: #eeeeee"
                  class="s-18 py-3 font-weight-600 col-md-12"
                >
                  Payment Summary({{ selectedCurrency.shortCode }})
                </div>
                <!-- Selected Products -->
                <div
                  class="row mt-3 normal-text"
                  v-for="item in checkedBoxArr"
                  :key="item.id"
                >
                  <div class="col-md-6 col-6">{{ item.name }}</div>
                  <div class="col-md-6 col-6 text-right font-weight-bold">
                    {{
                      daysToEndOfSubscription > 0
                        ? (
                            item.price * subscriptionDuration +
                            (item.price / 30) * daysToEndOfSubscription
                          ).toFixed(2)
                        : (item.price * subscriptionDuration).toFixed(2)
                    }}
                  </div>
                </div>
                <hr />
                <div class="row mt-3 px-3">
                  <div class="col-md-6 col-6">Total</div>
                  <div class="col-md-6 col-6 text-right font-weight-bold">
                    {{ TotalAmount.toLocaleString() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="row">
            <div
              class="col-md-4 col-lg-12 col-12 subb mt-4 mt-md-0 px-4 py-3 d-block d-md-none card-bg"
            >
              <div class="row rounded pb-2">
                <div class="col-md-12 s-13" style="color: #878787">
                  ACCOUNT STATUS BOARD
                </div>
                <div class="col-12 mt-1 col-sm-6">
                  <div class="s-13 fw-400 text-dak">Current plan</div>
                  <div class="fw-500 s-18 text-dak mt-1">
                    {{ currentPlan }}
                  </div>
                </div>
                <div class="col-12 col-sm-6 mt-3 mt-sm-0">
                  <div class="s-13 fw-400 text-dak">Expiry Date</div>
                  <div class="text-dak fw-500 s-18 mt-1">
                    {{ expiryDate }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-11 offset-md-1 subb px-4 py-3 d-none d-md-block card-bg"
            >
              <div class="row rounded pb-2">
                <div class="col-md-12 s-13" style="color: #878787">
                  ACCOUNT STATUS BOARD
                </div>
                <div class="col-12 mt-1">
                  <div class="s-13 fw-400 text-dak">Current plan</div>
                  <div class="fw-500 s-18 text-dak mt-1">
                    {{ currentPlan }}
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="s-13 fw-400 text-dak">Expiry Date</div>
                  <div class="text-dak fw-500 s-18 mt-1">
                    {{ expiryDate }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-11 col-12 offset-md-1 subb px-4 py-3 mt-4 card-bg"
            >
              <div class="row pb-2">
                <div
                  class="col-md-12"
                  :class="{
                    showDropdownMenu: showTransferDetail,
                    hideDropdownMenu: !showTransferDetail,
                  }"
                >
                  <div class="row mt-3">
                    <div class="col-md-12 d-flex justify-content-between">
                      <div class="text-dak s-15 font-weight-600">
                        Subscription Status
                      </div>
                      <span class="fw-400 text-dak s-15">{{
                        new Date(expiryDate) >= new Date()
                          ? "Active"
                          : "InActive"
                      }}</span>
                    </div>
                    <div class="col-md-12 d-flex mt-2 justify-content-between">
                      <div class="text-dak s-15 font-weight-600">
                        Start Date
                      </div>
                      <span class="fw-400 text-dak s-15">{{
                        modifiedSubcriptionDate
                      }}</span>
                    </div>
                    <div class="col-md-12 mt-2 d-flex justify-content-between">
                      <div class="text-dak s-15 font-weight-600">
                        Renewal date
                      </div>
                      <span class="fw-400 text-dak s-15">{{ expiryDate }}</span>
                    </div>
                    <div class="col-md-12 mt-2 d-flex justify-content-between">
                      <div class="text-dak s-15 fw-400">
                        Next Payment Due on
                        <span class="text-dak s-15 font-weight-bold">{{
                          subtractDays(expiryDate, 2)
                        }}</span>
                      </div>
                      <span
                        class="fw-500 text-dak s-18"
                        v-if="
                          stripeCustomerPortal.data !== 1 &&
                          stripeCustomerPortal.data !== ''
                        "
                      >
                        <a
                          :href="stripeCustomerPortal.data"
                          class="text-decoration-none text-dak"
                          target="_blank"
                        >
                          <el-button
                            color="#F9FFAA"
                            size="large"
                            :loading="loading"
                            class="text-dak border-radius-8"
                            style="border: 1px solid #d9d0d0"
                          >
                            <span class="s-12 fw-500"
                              >Manage Subscription</span
                            ></el-button
                          >
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row mt-4">
            <div class="col-md-6" @click="setPayNow">
              <el-button
                :color="primarycolor"
                class="w-100"
                round
                :disabled="!selectedPlanId"
              >
                Pay Now
              </el-button>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
        <!-- </div>  -->
      </div>

      <!-- Add ons -->

      <div v-if="false" class="col-md-6 col-lg-6 p-4 sub mt-3 bg-white">
        <div class="">
          <div class="small-header">Communication</div>
          <div class="row mt-3 normal-text">
            <div class="col-md-2 col-lg-2 col-4">SMS</div>
            <div class="col-md-6 offset-md-1 col-4 mb-2">
              <input
                type="number"
                v-model.number="smsValue"
                class="form-control w-50"
                placeholder="SMS Unit"
              />
            </div>
            <div class="col-md-2 col-4">
              {{ smsAmount }}
            </div>
          </div>
          <div class="row mt-2 normal-text">
            <div class="col-md-2 col-lg-2 col-4">Email</div>
            <div class="col-md-6 offset-md-1 col-4">
              <el-select-v2
                :options="
                  selectEmailUnit.map((i) => ({ label: i.name, value: i.name }))
                "
                v-model="selectEmail"
                placeholder="Email unit"
                size="large"
                class="w-100"
              />
            </div>
            <div class="col-md-2 col-4">
              {{ selectEmail.constValue ? emailAmount : 0 }}
            </div>
          </div>
          <div class="my-3 small-header">
            Accounting <br /><small
              >Product price is multiplied by subscrption duration</small
            >
          </div>
          <div
            class="row normal-text"
            v-for="item in productsList"
            :key="item.id"
          >
            <div class="col-12" v-if="item.type === 0">
              <div class="row">
                <div class="col-md-6 col-4">{{ item.name }}</div>
                <div class="col-md-2 col-4">
                  <input type="checkbox" @change="selectCheckbox(item)" />
                </div>
                <div class="col-md-4 text-center col-4">{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- payment summary -->

      <el-dialog
        title="Payment status"
        v-model="display"
        :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : xsOnly ? `90%` : `70%`"
        align-center
        :modal="true"
      >
        <div class="row">
          <div class="col-md-12" v-if="!paymentFailed">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <img
                  src="../../assets/successful_payment.png"
                  style="width: 250px; margin: auto"
                />
              </div>
              <h3 class="text-center mt-5 font-weight-bold success">
                Congrats
              </h3>
              <div class="text-center mt-2 font-weight-600 s-18">
                Your subscription payment is successful <br />Your account has
                been upgraded successfully <br />Click the button below to go to
                the dashboard
              </div>
              <div class="d-flex justify-content-center mb-5">
                <a :href="dashboardURL" class="no-decoration">
                  <el-button color="#70c043" class="text-white mt-3" round
                    >Go to dashboard</el-button
                  >
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-else>
            <h4 class="text-danger">Oops,</h4>
            <p>
              Sorry, your subscription upgrade was not successful, please
              contact support at
              <span class="font-weight-bold">info@churchplus.co</span>
            </p>
          </div>
        </div>
      </el-dialog>
      <!-- payment summary end -->
      <!-- Modal -->
    </div>
  </div>
  <el-dialog
    v-model="showPaymentGatewayOptions"
    title=""
    class="expiredSubDial border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : `90%`"
    align-center
    :show-close="false"
  >
    <div class="row">
      <div class="col-md-12 px-3 d-flex justify-content-between">
        <div class="s-20 font-weight-600 text-black">Continue Payment with</div>
        <div>
          <el-button class="border-0" @click="closePaymentModal"
            ><el-icon :size="20"><Close /></el-icon
          ></el-button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="p-0 col-md-12 mt-4 pb-5">
          <div
            class="row row-button c-pointer border-top d-flex justify-content-center"
            @click="initializePayment(2)"
          >
            <div>
              <img
                style="width: 80px"
                src="../../assets/stripe.png"
                alt="strip"
              />
            </div>
            <div class="w-100 text-center mb-2 text-dak">Subscription</div>
          </div>

          <div
            class="row row-button c-pointer border-top d-flex justify-content-center"
            @click="initializePayment(0)"
            v-if="
              currentUser.currency == 'NGN' || currentUser.currency == 'GHS'
            "
          >
            <div>
              <img
                style="width: 150px"
                src="../../assets/4PaystackLogo.png"
                alt="paystack"
              />
            </div>
          </div>
          <div
            class="row row-button c-pointer d-flex justify-content-center"
            @click="initializePayment(1)"
          >
            <div>
              <img
                style="width: 150px"
                src="../../assets/flutterwave_logo_color@2x.png"
                alt="flutterwave"
              />
            </div>
          </div>
          <div
            @click="setPayPal"
            class="row row-button c-pointer d-flex justify-content-center"
          >
            <!-- <a
              href="https://www.paypal.me/GeorgeOnyeama?locale.x=en_GB"
              target="_blank"
            > -->
            <div>
              <img
                style="width: 120px; height: 30px"
                src="../../assets/PayPal2.png"
                alt="paypal"
              />
            </div>
            <!-- </a> -->
          </div>
          <div
            @click="setDirectTransfer"
            class="row row-button c-pointer d-flex justify-content-center"
          >
            <div class="gradient-text s-18 font-weight-600">
              Direct Bank Transfer
            </div>
            <!-- </a> -->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showPayPal"
    title=""
    class="expiredSubDialog border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row">
      <div class="col-md-11 col-12">
        <div
          class="col-md-12 s-20 text-black text-center font-weight-bold text-head"
        >
          Prove of Payment
        </div>
        <div class="col-md-12 s-18 text-black text-center mt-4">
          Send Your Prove Of Payment or login detail to this Email
        </div>
        <div
          class="col-md-12 s-18 text-black mt-2 d-flex font-weight-600 text-center justify-content-center text-head"
        >
          <span class="mr-2">Email:</span>
          <span>churchplusnig@gmail.com</span>
        </div>
        <div class="d-flex col-md-12 mt-4 justify-content-center">
          <a
            href="https://www.paypal.me/GeorgeOnyeama?locale.x=en_GB"
            target="_blank"
          >
            <el-button
              class="ml-3 primary-bg text-white"
              @click="continueWithPayment"
              round
            >
              Continue
            </el-button>
          </a>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showDirectTransfer"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12 subb px-4 py-3 mt-4 card-bg">
        <div class="row pb-2">
          <div class="gradient-text font-weight-600 col-md-8 s-20">
            Direct Bank Transfer details
          </div>
          <div class="col-md-12 pb-2">
            <div class="row mt-3">
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Name:</div>
                <span class="fw-500 text-dak">Complustech Limited</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Number:</div>
                <span class="fw-500 text-dak">0017934252</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Bank:</div>
                <span class="fw-500 text-dak">Access</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">
                  Send Prove Of Payment or login detail to:
                </div>
                <span class="fw-500 text-dak">08023739961</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showPaymentOptionModal"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12">
        <!-- Payment Options -->
        <div class="col-md-12 px-0 font-weight-600 gradient-text">
          Direct Bank Transfer
        </div>
        <div class="text-dak px-0 col-md-12">I am paying from</div>
        <div class="col-md-12 px-0 mt-3">
          <div
            v-for="(option, index) in paymentOptions"
            :key="index"
            class="d-flex justify-content-between align-items-center py-3"
            :class="{ 'border-botto': index < 1 }"
          >
            <div class="fw-400 text-dak s-24">{{ option.label }}</div>
            <div>
              <input
                type="radio"
                name="paymentLocation"
                :value="option.value"
                v-model="selectedOption"
                @change="setSelectedOption(selectedOption)"
                class="form-check-inp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import axios from "@/gateway/backendapi";
import { useStore } from "vuex";
import formatDate from "../../services/dates/dateformatter";
import { computed, onMounted, ref, inject, nextTick } from "vue";
import membershipService from "../../services/membership/membershipservice";
import productPricing from "../../services/user/productPricing";
import { ElMessage, ElMessageBox } from "element-plus";
import { ElLoading } from "element-plus";
import { useRouter } from "vue-router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";

export default {
  setup() {
    const primarycolor = inject("primarycolor");
    const store = useStore();
    const subscriptionPlans = ref([]);
    const productsList = ref([]);
    const selectMonth = ref({});
    const selectedPlan = ref({});
    const currentAmount = ref("");
    const stripeCustomerPortal = ref("");
    const currentPlan = ref("");
    const smsValue = ref();
    const selectAmount = ref("");
    const constValue = ref(0);
    const selectEmail = ref({});
    const emailPrice = ref("");
    const smsPrice = ref("");
    const expenseApp = ref("");
    const fixedAsset = ref("");
    const showPayPal = ref(false);
    const showPaymentGatewayOptions = ref(false);
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    const dashboardURL = ref(`${window.location.origin}/tenant`);
    const acctReceived = ref("");
    const paymentSummary = ref([]);
    const paymentSummObj = ref({});
    const isChecked = ref(false);
    const showTransferDetail = ref(false);
    const selectedOption = ref("");
    const checkedBoxArr = ref([]);
    const selectCurrencyArr = ref([]);
    const Plans = ref({});
    const display = ref(false);
    const loading = ref(false);
    const showDirectTransfer = ref(false);
    const showPaymentOptionModal = ref(false);
    const currencies = ref({});
    const emailSelectedValue = ref("");
    const subSelectedAmount = ref("");
    const isProduction = true;
    const initializedOrder = ref("");
    const churchLogo = ref("");
    const expiryDate = ref("");
    const modifiedSubcriptionDate = ref("");
    const payload = ref({});
    const selectMonths = ref([
      { name: "1", code: "NY" },
      { name: "2", code: "RM" },
      { name: "3", code: "LDN" },
      { name: "4", code: "IST" },
      { name: "5", code: "PRS" },
      { name: "6", code: "NY" },
      { name: "7", code: "RM" },
      { name: "8", code: "LDN" },
      { name: "9", code: "IST" },
      { name: "10", code: "PRS" },
      { name: "11", code: "IST" },
      { name: "12", code: "PRS" },
    ]);

    const selectEmailUnit = ref([
      { name: "1000-2000", constValue: 2 },
      { name: "2000-3000", constValue: 4 },
      { name: "3000-4000", constValue: 6 },
      { name: "4000-5000", constValue: 8 },
    ]);
    const paymentOptions = ref([
      { label: "United States", value: "us" },
      { label: "Nigeria/Africa", value: "ng" },
    ]);
    selectCurrencyArr.value = ["NGN", "USD", "GHS", "ZAR"];
    const existingPlan = ref({});
    const daysToEndOfSubscription = ref(0);
    const UserSubscriptionPricing = ref([]);
    const UserSubscriptionPlans = ref([]);
    const selectedPlanId = ref(null);
    const selectMonthId = ref(null);
    const router = useRouter();
    const stripe = ref(null);

    const setPayPal = () => {
      showPayPal.value = true;
    };
    const billingHistory = () => {
      router.push("/tenant/billing-history");
    };

    const continueWithPayment = () => {
      showPayPal.value = false;
      showPaymentGatewayOptions.value = false;
    };

    const setDirectTransfer = () => {
      // showDirectTransfer.value = true;
      showPaymentOptionModal.value = true;
    };
    const setSelectedOption = (item) => {
      console.log(item, "hhjjs");
      if (item == "us") {
        // showDirectTransfer.value = true;
        initializePayment(2);
      } else {
        showDirectTransfer.value = true;
        // showPaymentOptionModal.value = false;
      }

      // showDirectTransfer.value = true;
      // showPaymentOptionModal.value = true
    };

    const closePaymentModal = () => {
      showPaymentGatewayOptions.value = false;
    };
    const setPayNow = async () => {
      showPaymentGatewayOptions.value = true;
      showPayPal.value = false;
    };
    const dateFormat = (date) => {
      return formatDate.monthDayYear(date);
    };
    onMounted(async () => {
      stripe.value = await loadStripe(
        String(process.env.VUE_APP_STRIPE_PUBLIC_KEY_LIVE)
        // String(process.env.VUE_APP_STRIPE_PUBLIC_KEY_TEST)
      );

      // And in your mounted hook
      // console.log(process.env.VUE_APP_STRIPE_PUBLIC_KEY_TEST, "stripe key");
    });

    const currentUser = computed(() => {
      if (
        !store.getters.currentUser ||
        (store.getters.currentUser &&
          Object.keys(store.getters.currentUser).length == 0)
      )
        return "";
      return store.getters.currentUser;
    });

    const manageSubscription = async () => {
      loading.value = true;
      try {
        const data = await axios.get(
          "/api/Payment/StripeCustomerPortalManagement"
        );
        stripeCustomerPortal.value = data;
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };
    manageSubscription();

    const setCurrentUser = async () => {
      membershipService.getSignedInUser().then((res) => {
        store.dispatch("setCurrentUser", res);
        getChurchProfile();
      });
    };
    if (
      !currentUser.value ||
      (currentUser.value && Object.keys(currentUser.value).length == 0)
    )
      setCurrentUser();

    const getProductPricing = async (id) => {
      let { data } = await productPricing.getProductPricing(id);
      data.forEach((i) => {
        if (i.product.name.toLowerCase() === "subscription") {
          UserSubscriptionPricing.value.push(i);
        }
      });

      getTenantSubscription();
      UserSubscriptionPlans.value = UserSubscriptionPricing.value
        .sort((a, b) => a.order - b.order)
        .map((i) => {
          i.subscriptionPlan.amount = i.price;
          i.subscriptionPlan.currency = i.currency;
          i.subscriptionPlan.flutterWavePriceId = i.flutterWavePriceId;
          i.subscriptionPlan.stripePriceId = i.stripePriceId;
          i.subscriptionPlan.paystackPriceId = i.paystackPriceId;
          return i.subscriptionPlan;
        });
      selectMonthId.value = 1;
      selectMonth.value = selectMonths.value.find(
        (i) => i.name == selectMonthId.value
      );
    };

    const subtractDays = (dateString, days) => {
      // Convert the string to a Date object
      const date = new Date(dateString);

      date.setDate(date.getDate() - days);
      return formatDate.monthDayYear(date);
    };

    const getTenantSubscription = () => {
      axios.get("/api/Subscription/subscriptions").then((res) => {
        Plans.value = res.data;
        existingPlan.value.id = Plans.value.id;
        existingPlan.value.amount = Plans.value.amount;
        existingPlan.value.description = Plans.value.description;
        existingPlan.value.amountInDollar = Plans.value.amountInDollar;
        existingPlan.value.membershipSize = Plans.value.membershipSize;

        res.data.subscriptionPlans.forEach((i) => {
          if (i.membershipSize >= Plans.value.membershipSize) {
            subscriptionPlans.value.push(i);
          }
        });

        // Get current plan

        selectedPlan.value = UserSubscriptionPlans.value.find(
          (i) => i.id == Plans.value.id
        );

        selectedPlanId.value = UserSubscriptionPlans.value.find((i) => {
          return i.id == Plans.value.id;
        })
          ? UserSubscriptionPlans.value.find((i) => {
              return i.id == Plans.value.id;
            }).id
          : null;

        // Remove preceeding plans from list

        const joined = UserSubscriptionPlans.value.map((i) => i.id).join("");
        const splitted = joined.split(selectedPlan.value.id);
        UserSubscriptionPlans.value = UserSubscriptionPlans.value.splice(
          splitted[0].length
        );

        if (selectedPlanId.value == null) {
          ElMessageBox.confirm(
            "Subscription pricing is currently not available in your country, we will make it available as soon as possible, you can reach out to us by sending an email to info@churchplus.co for us to address your specific needs. Thank you for choosing Churchplus",
            "Notice",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              ElMessage({
                type: "warning",
                message: "We await your feedback. Thank you",
              });
            })
            .catch(() => {
              ElMessage({
                type: "warning",
                message: "We await your feedback. Thank you",
              });
            });
        }

        currentAmount.value = res.data.amountInNaira;
        currentPlan.value = existingPlan.value.description;
        productsList.value = res.data.productsList;
        expiryDate.value = formatDate.monthDayYear(
          Plans.value.subscriptionExpiration
        );
        modifiedSubcriptionDate.value = formatDate.monthDayYear(
          Plans.value.modifiedSubcriptionDate
        );
        emailPrice.value =
          productsList.value && productsList.value.length > 0
            ? productsList.value.find((i) => i.name === "Email").price
            : [];
        smsPrice.value =
          productsList.value && productsList.value.length > 0
            ? productsList.value.find((i) => i.name === "SMS").price
            : [];

        daysToEndOfSubscription.value =
          calculateRemomainingMonthsOfSubscription(
            res.data.subscriptionExpiration
          );
      });
    };

    const setSelectedDuration = () => {
      selectMonth.value = selectMonths.value.find(
        (i) => i.name == selectMonthId.value
      );
    };

    const setSelectedPlan = () => {
      selectedPlan.value = UserSubscriptionPlans.value.find(
        (i) => i.id == selectedPlanId.value
      );
    };

    const getChurchProfile = async () => {
      try {
        let res = await axios.get(
          `/GetChurchProfileById?tenantId=${currentUser.value.tenantId}`
        );
        churchLogo.value = res.data.returnObject.logo;
        getProductPricing(res.data.returnObject.countryID);
      } catch (err) {
        console.log(err);
      }
    };
    if (currentUser.value && Object.keys(currentUser.value).length > 0)
      getChurchProfile();

    const paymentFailed = ref(false);

    const emailAmount = computed(() => {
      if (!selectEmail.value.name) return 0;
      return +selectEmail.value.name.split("-")[1] * emailPrice.value;
    });

    const smsAmount = computed(() => {
      if (!smsValue.value) return 0;
      return smsValue.value * smsPrice.value;
    });

    const subselectedDuratn = computed(() => {
      let multiValue = 1;
      if (selectedPlan.value && selectedPlan.value.amount)
        multiValue *= selectedPlan.value.amount;
      if (selectMonth.value.name) multiValue *= +selectMonth.value.name;
      return multiValue;
    });

    const TotalAmount = computed(() => {
      let sum = 0;
      if (subselectedDuratn.value && selectMonth.value.name > 0)
        sum += subselectedDuratn.value;
      if (smsValue.value) sum += smsValue.value * 2;
      sum += emailAmount.value;
      return sum + +sumCheckboxItem.value.toFixed(2);
    });
    const sumCheckboxItem = computed(() => {
      if (checkedBoxArr.value.length === 0) return 0;
      return checkedBoxArr.value
        .map((i) => calculatedProductPrice(i.price))
        .reduce((a, b) => a + b);
    });

    const selectCheckbox = (item) => {
      const index = checkedBoxArr.value.findIndex((i) => i.name === item.name);
      if (index < 0) {
        checkedBoxArr.value.push(item);
      } else {
        checkedBoxArr.value.splice(index, 1);
      }
    };

    const selectedCurrency = computed(() => {
      if (
        selectedPlan.value &&
        Object.keys(selectedPlan.value).length > 0 &&
        selectedPlan.value.currency
      )
        return selectedPlan.value.currency;
      return "";
    });

    const initializePayment = (paymentGateway) => {
      const loading = ElLoading.service({
        lock: true,
        text: "Please wait...",
        background: "rgba(255, 255, 255, 0.9)",
      });
      if (paymentGateway === 2) {
        payload.value = {
          subscriptionPlanID: selectedPlan.value.id,
          paymentGateway: "Stripe",
          totalAmount: TotalAmount.value,
          durationInMonths: selectMonthId.value,
          productPriceId: UserSubscriptionPlans.value[0].stripePriceId,
          currencyId: selectedCurrency.value.id,
          currency: selectedCurrency.value.shortCode,
        };
        console.log(payload.value, "hhhh");
      } else {
        payload.value = {
          subscriptionPlanID: selectedPlan.value.id,
          paymentGateway: paymentGateway === 0 ? "Paystack" : "Flutterwave",
          totalAmount: TotalAmount.value,
          productPriceId:
            paymentGateway === 0
              ? UserSubscriptionPlans.value[0].paystackPriceId
              : UserSubscriptionPlans.value[0].flutterWavePriceId,
          durationInMonths: selectMonthId.value,
          currencyId: selectedCurrency.value.id,
        };
        console.log(payload.value, "hhhh");
      }

      axios
        .post("/api/Payment/InitializeSubscription", payload.value)
        .then(({ data }) => {
          console.log(data);
          // initializedOrder.value = res.data;
          loading.close();
          if (data.status) {
            if (paymentGateway == 0) {
              payWithPaystack(data);
            } else if (paymentGateway == 1) {
              payWithFlutterwave(data);
            } else {
              payWithStripe(data);
            }
          }
        });
    };

    const subscriptionPayment = async (trans_id, tx_ref) => {
      try {
        await axios
          .post(
            `/api/Payment/ConfirmSubscriptionPayment?id=${trans_id}&txnref=${tx_ref}`
          )
          .then((res) => {
            console.log(res);
            display.value = true;
            if (res.data) {
              paymentFailed.value = false;
            } else {
              paymentFailed.value = true;
            }
          })
          .catch((err) => {
            console.log(err);
            display.value = true;
            paymentFailed.value = true;
          });
      } catch (error) {
        console.log(error);
      }
    };

    const payWithPaystack = (responseObject) => {
      let handler = PaystackPop.setup({
        key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY_LIVE,
        // key: process.env.VUE_APP_PAYSTACK_API_KEY,
        email: "info@churchplus.co",
        amount: TotalAmount.value * 100,
        currency: selectedCurrency.value.shortCode,
        channels: [
          "card",
          "bank",
          "ussd",
          "qr",
          "mobile_money",
          "bank_transfer",
        ],
        ref: responseObject.transactionReference,
        onClose: function () {
          ElMessage({
            type: "info",
            showClose: true,
            message: "You have cancelled the transaction",
            duration: 5000,
          });
        },
        callback: function (response) {
          let trans_id = response.trxref;
          let tx_ref = response.trxref;
          subscriptionPayment(tx_ref, trans_id);
        },
      });
      handler.openIframe();
    };
    const payWithStripe = async (responseObject) => {
      sessionStorage.setItem(
        "previousRoute",
        router.currentRoute.value.fullPath
      );
      try {
        // Redirect user to Stripe Checkout
        const { error } = await stripe.value.redirectToCheckout({
          sessionId: responseObject.clientSecret, // Ensure your backend returns this
        });

        if (error) {
          console.log("Stripe Checkout error:", error);
          ElMessage({
            type: "error",
            showClose: true,
            message: "Payment failed. Please try again.",
            duration: 5000,
          });
        }
      } catch (error) {
        console.error("Error initializing Stripe:", error);
      }
    };
    const getFlutterwaveModules = () => {
      const script = document.createElement("script");
      script.src = !isProduction
        ? "https://ravemodal-dev.herokuapp.com/v3.js"
        : "https://checkout.flutterwave.com/v3.js";
      document.getElementsByTagName("head")[0].appendChild(script);
    };
    getFlutterwaveModules();

    const payWithFlutterwave = (responseObject) => {
      console.log(responseObject, "flutterwave");

      let country = "";

      switch (selectedCurrency.value.shortCode) {
        case "KES":
          country = "KE";
          break;
        case "GHS":
          country = "GH";
          break;
        case "ZAR":
          country = "ZA";
          break;
        case "TZS":
          country = "TZ";
          break;

        default:
          country = "NG";
          break;
      }

      window.FlutterwaveCheckout({
        // public_key: process.env.VUE_APP_FLUTTERWAVE_TEST_KEY,
        public_key: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY_LIVE,
        tx_ref: responseObject.transactionReference,
        amount: TotalAmount.value,
        currency: selectedCurrency.value.shortCode,
        country: country,
        payment_options: "card,ussd",
        customer: {
          name: currentUser.value.churchName,
          email: currentUser.value.userEmail,
        },
        callback: (response) => {
          let trans_id = response.transaction_id;
          let tx_ref = response.tx_ref;
          subscriptionPayment(trans_id, tx_ref);
        },
        onclose: () => console.log("Payment closed"),
        customizations: {
          title: "Subscription",
          description: "Payment for Subcription ",
          logo: churchLogo.value,
        },
      });
    };
    const calculateRemomainingMonthsOfSubscription = (expiryDate) => {
      const endDate = new Date(expiryDate);
      const startDate = new Date(Date.now());

      const differenceInTime = Math.abs(endDate - startDate);
      const differenceInDays = Math.ceil(
        differenceInTime / (1000 * 60 * 60 * 24)
      );

      return differenceInDays;
    };

    const subscriptionDuration = computed(() => {
      if (selectMonth.value.name) return +selectMonth.value.name;
      return 0;
    });

    const calculatedProductPrice = (price) => {
      if (daysToEndOfSubscription.value < 1)
        return selectMonth.value.name ? price * +selectMonth.value.name : 0;
      return (
        (selectMonth.value.name ? price * +selectMonth.value.name : 0) +
        (price / 30) * daysToEndOfSubscription.value
      );
    };

    return {
      selectedPlan,
      selectedOption,
      setSelectedOption,
      showDirectTransfer,
      showPaymentOptionModal,
      setDirectTransfer,
      paymentOptions,
      billingHistory,
      subtractDays,
      dateFormat,
      stripeCustomerPortal,
      payload,
      stripe,
      loading,
      showPaymentGatewayOptions,
      showPayPal,
      continueWithPayment,
      setPayPal,
      setPayNow,
      getTenantSubscription,
      closePaymentModal,
      modifiedSubcriptionDate,
      subscriptionPlans,
      currentAmount,
      currentPlan,
      constValue,
      smsValue,
      selectMonth,
      selectMonths,
      selectAmount,
      selectEmailUnit,
      selectEmail,
      emailPrice,
      productsList,
      emailAmount,
      emailSelectedValue,
      subSelectedAmount,
      TotalAmount,
      expiryDate,
      subselectedDuratn,
      expenseApp,
      showTransferDetail,
      fixedAsset,
      acctReceived,
      paymentSummary,
      paymentSummObj,
      isChecked,
      selectCheckbox,
      checkedBoxArr,
      sumCheckboxItem,
      smsPrice,
      smsAmount,
      currentUser,
      existingPlan,
      Plans,
      selectCurrencyArr,
      selectedCurrency,
      currencies,
      display,
      paymentFailed,
      daysToEndOfSubscription,
      subscriptionDuration,
      initializePayment,
      initializedOrder,
      UserSubscriptionPricing,
      UserSubscriptionPlans,
      selectedPlanId,
      selectMonthId,
      setSelectedDuration,
      setSelectedPlan,
      churchLogo,
      mdAndUp,
      lgAndUp,
      xlAndUp,
      xsOnly,
      dashboardURL,
      primarycolor,
    };
  },
};
</script>

<style scoped>
.sub {
  box-shadow: 4px 4px 8px 0px #00000045;
  border: 1px solid #d3d3d3;

  border-radius: 8px;
  /* padding: 20px; */
}
.gradient-text {
  background: linear-gradient(90deg, #671414 0%, #0b55d5 100%);
  background-clip: text;
  color: transparent;
}
.subb {
  background: #fafafa;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}

.plandropdown {
  text-align: left;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}

.communication {
  background: #ffffff 0% 0% no-repeat padding-box;
  /* box-shadow: 4px 10px 35px #0000000d; */
  border: 1px solid #0f022021;
  border-radius: 15px;
  opacity: 1;
}

.payment {
  box-shadow: 4px 10px 35px #0000000d;
  border: 1px solid #0f022021;
  border-radius: 15px;
  opacity: 1;
}

.pay-now {
  background: #136acd 0% 0% no-repeat padding-box;
  border-radius: 22px;
}

.row-button {
  padding: 15px;
  /* border-radius: 8px; */
  /* box-shadow: 0 4px 12px rgb(0 0 0 / 10%); */
  /* background: #fafafa; */
  border-bottom: 1px solid #bfd7ff;
  /* margin: 12px 70px 15px 70px; */
  transition: all 0.4s ease-in-out;
  max-height: 70px;
}

.continue-text {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
}

.emailWidth {
  width: 60%;
}

.form-control {
  width: 60% !important;
}

.italic {
  font-style: italic;
}

.card-bg {
  background: #fafafa;
}
</style>
